import {getAction} from "@api/manage";
import {replaceString} from "@/utils/Tool";

export async function getDataJson(cptDataForm, queryParam, cptType) {
    let resStr = '{}';
    //防止JSON解析报错
    let iptStr = cptDataForm.dataText;
    if (cptDataForm.dataSource === 1) {
        resStr = JSON.parse(iptStr);
    } else if (cptDataForm.dataSource === 2) {
        //调接口
        iptStr = cptDataForm.apiUrl
        if (iptStr) {
            let url = replaceString(iptStr, queryParam) + `?cptType=${cptType}`
            await getAction(url).then(res => {
                resStr = res.result ? res.result : res;
            })
        }
    } else if (cptDataForm.dataSource === 3) {
        iptStr = cptDataForm.sql
        if (iptStr) {
            await getAction({sql: iptStr}).then(res => {
                resStr = res.data;
            })
        } else {
        }
    }
    return resStr;
}

let cptTimer = {}

export function pollingRefresh(uuid, cptDataForm, loadData) {
    if (uuid) {
        clearInterval(cptTimer[uuid]);
        //清除旧的定时器
    }
    if (!cptDataForm) {
        return;
    }
    if (!loadData) {
        return;
    }
    loadData();
    if (cptDataForm.pollTime && cptDataForm.pollTime !== 0) {
        //轮询
        cptTimer[uuid] = setInterval(function () {
            loadData();
        }, cptDataForm.pollTime * 1000)
    }
}

export function clearCptInterval(uuid, clearAll) {
    if (uuid) {
        clearInterval(cptTimer[uuid]);
        //清除旧的定时器
    }
    if (clearAll) {
        for (const key in cptTimer) {
            clearInterval(cptTimer[key]);
        }
    }
}
